import React, { useState, useEffect } from 'react'
import isTokenStructureValid from '../authHelpers/isTokenStructureValid';
import getUserData from '../userServices/getUserData';
import handleLogout from '../authHelpers/handleLogout';
import Spinner from '../Spinner';

const LoginStatusButton = ({props, loginPage, checkoutPage, registrationPage}) => {
  const {loginPageUrl, registrationPageUrl, profileUrl, signOutUrl} = props;

  const [isLoaded, setIsLoaded] = useState(false)
  const [token, setToken] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [localUserData, setLocalUserData] = useState({})

  useEffect(() => {
    if(token && isTokenStructureValid(token) && Object.keys(localUserData).length !== 0) {
      setName(localUserData.username)
      setEmail(localUserData.email)
      setIsLoaded(true);
    } else {
      setIsLoaded(true);
    }
  }, [token, localUserData])
  

  useEffect(() => {
    getUserData().isUserDataCorrect && setLocalUserData(getUserData().localUserData)
    setToken(getUserData().token)
    
    const handleChangedUserDataCustomEvent = (event) => {
      const userData = JSON.parse(event.detail.userData);
      setName(userData.username)
      setEmail(userData.email)
    };

    window.addEventListener("changedUserData", handleChangedUserDataCustomEvent);

    return () => {
      window.removeEventListener("changedUserData", handleChangedUserDataCustomEvent);
    };
  }, [])

  return (
    <>
        <button aria-label="profile button" className="uk-button uk-button-default uk-button-tertiary button-shadow profile-button">
          <span className="color-secondary-dark">
            <svg width="14" height="18" viewBox="0 0 14 18" fill="inherit" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 15.6712C0 12.5859 1.94026 8.32927 7 8.32927C12.0597 8.32927 14 12.5859 14 15.6712C14 16.8281 10.5 18 7 18C3.5 18 0 16.8281 0 15.6712ZM3.41159 3.68788C3.41159 4.41727 3.62205 5.13029 4.01635 5.73676C4.41065 6.34322 4.97108 6.81591 5.62678 7.09504C6.28247 7.37416 7.00398 7.4472 7.70007 7.3049C8.39615 7.1626 9.03554 6.81136 9.53739 6.2956C10.0392 5.77984 10.381 5.12273 10.5195 4.40735C10.6579 3.69197 10.5869 2.95046 10.3153 2.27659C10.0437 1.60272 9.58373 1.02675 8.99362 0.621519C8.4035 0.21629 7.70972 -3.82522e-07 7 0C6.0483 5.12947e-07 5.13557 0.388544 4.46261 1.08016C3.78965 1.77177 3.41159 2.70979 3.41159 3.68788Z" fill="#014B64"/>
            </svg>
          </span>
        </button>

        <div className="uk-border-rounded uk-box-shadow-small uk-padding-remove" uk-dropdown="pos: bottom-right; mode: click;">
          {isLoaded ?
            <>
              {token && isTokenStructureValid(token) && Object.keys(localUserData).length !== 0 ? 
              <div>
                  <div className="user-info uk-padding-small">
                      <a href={`${profileUrl}`} className="uk-text-bold color-secondary-dark">{name}<span className="uk-sr-only" data-sf-role="sf-logged-in-name"></span></a>
                      <p className="color-primary-blue">{email}<span className="uk-sr-only" data-sf-role="sf-logged-in-email"></span></p>
                  </div>
                  <hr />
                  <button onClick={() => handleLogout()} className="uk-button uk-button-text uk-padding-small uk-text-normal uk-text-transform-none color-black"><span>Logout</span></button>
              </div>
              : <div data-sf-role="sf-logged-out-view">
                  <a href={loginPageUrl} className="uk-button uk-button-text uk-padding-small uk-text-normal uk-text-transform-none color-black"><span>Login</span></a>
                  <hr />
                  <a href={registrationPageUrl} className="uk-button uk-button-text uk-padding-small uk-text-normal uk-text-transform-none color-black"><span>Register</span></a>
                </div>
              }
            </> :
            <div className="uk-padding uk-flex uk-flex-center">
              <Spinner />
            </div>
          }
        </div>
      </>
  )
}

export default LoginStatusButton
